import { Button } from '@mui/material';
import { INode } from '../../Context/FormBuilderContext';

interface SubmitWidgetProps {
  node: INode;
}

export function SubmitWidget({ node }: SubmitWidgetProps) {
  const styles = node?.data?.styles;

  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        justifyContent: styles?.submit?.textAlign || 'center',
      }}
    >
      <Button
        variant="contained"
        size="small"
        sx={{
          backgroundColor: styles?.submit?.buttonBackgroundColor || '#3650DE',
          '&:hover': {
            backgroundColor: styles?.submit?.buttonBackgroundColor || '#2A3F9E',
            opacity: '0.8',
            boxShadow: 'none',
          },
          color: styles?.submit?.color || '#ffffff',
          fontFamily: styles?.submit?.fontFamily || 'Roboto, sans-serif',
          fontSize: `${styles?.submit?.fontSize || 16}px`,
          fontWeight: styles?.submit?.isBold ? '700' : '400',
          fontStyle: styles?.submit?.isItalic ? 'italic' : 'normal',
          textDecoration: styles?.submit?.isUnderlined ? 'underline' : 'none',
          padding: '8px 16px',
          height: '100%',
          boxShadow: 'none',
          lineHeight: '150%',
          letterSpacing: '0.5px',
        }}
      >
        Submit
      </Button>
    </div>
  );
}
